import { render, staticRenderFns } from "./NoAccessPage.vue?vue&type=template&id=4678b243"
import script from "./NoAccessPage.vue?vue&type=script&lang=js"
export * from "./NoAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports